<template>
  <div class="d-flex flex-column flex-column-fluid">
    <!-- Toolbar -->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <h1 class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
            منصة أكاديميا Academia
          </h1>
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <li class="breadcrumb-item text-muted">
              <a href="#" class="text-muted text-hover-primary">الصفحة الرئيسية</a>
            </li>
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <li class="breadcrumb-item text-muted">الرئيسية</li>
          </ul>
        </div>
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <!-- Additional actions here if needed -->
        </div>
      </div>
    </div>
    <!-- Content -->

    <div id="kt_app_content" class="app-content flex-column-fluid">
      <div id="kt_app_content_container" class="app-container container-fluid">
        <div v-if="isloading == true"
          style="font-weight: 800;border-radius: 10px;padding: 50px;font-size: large;text-align: center;background: #73737326;"
          class="loader text-success">
          جاري التحميل
          <div class="spinner-border text-success" role="status">
            <span class="sr-only"></span>
          </div>
        </div>

        <div class="row g-5 g-xl-10 mb-5 mb-xl-10">
          <div class="col-xl-6">
            <div class="row">

              <div class="col-xl-6 mb-2" v-if="isLoggedIn == true && isloading == false">
                <!--begin::Statistics Widget 5-->
                <a href="Wallet" class="card hoverable card-xl-stretch mb-xl-2" style="background: #07c232;">
                  <!--begin::Body-->
                  <div class="card-body">
                    <!--begin::Svg Icon | path: icons/duotune/ecommerce/ecm008.svg-->
                    <span class="svg-icon svg-icon-gray-100 svg-icon-3x ms-n1">
                      <i class="fas fa-wallet text-white fs-2qx lh-0"></i>

                    </span>
                    <!--end::Svg Icon-->
                    <div class="text-white fw-bold fs-2 mb-2 mt-5">
                      <span v-if="loadingBalance">
                        <div class="spinner-border" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </span>
                      <span v-else>{{ walletBalance }} د.ل</span>
                    </div>
                    <div class="fw-semibold text-white" style="border-radius: 5px;padding: 4px;background: #0000003d;">
                      شحن المحفظة
                      <i class="fa fa-arrow-left" style="color: #fff; margin-right: 10px"></i>
                    </div>
                  </div>
                  <!--end::Body-->
                </a>
                <!--end::Statistics Widget 5-->
              </div>
              <div class="col-xl-6" v-if="isLoggedIn == true && isloading == false">
                <!--begin::Statistics Widget 5-->
                <a href="Dashboard" class="card hoverable card-xl-stretch mb-xl-2" style="background: #07c232;">
                  <!--begin::Body-->
                  <div class="card-body">
                    <!--begin::Svg Icon | path: icons/duotune/ecommerce/ecm008.svg-->
                    <span class="svg-icon svg-icon-gray-100 svg-icon-3x ms-n1">
                      <i class="fas fa-play text-white fs-2qx lh-0"></i>

                    </span>
                    <!--end::Svg Icon-->
                    <div class="text-white fw-bold fs-2 mb-2 mt-5">
                      <span v-if="loadingCourses">
                        <div class="spinner-border" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </span>
                      <span v-else>{{ courseCount }}</span>
                    </div>
                    <div class="fw-semibold text-white" style="border-radius: 5px;padding: 4px;background: #0000003d;">
                      الدورات المشترك بها
                      <i class="fa fa-arrow-left" style="color: #fff; margin-right: 10px"></i>
                    </div>
                  </div>
                  <!--end::Body-->
                </a>
                <!--end::Statistics Widget 5-->
              </div>
              <div class="col-xl-12 lives-tab"
                v-if="(tab === 'nearLive' && this.nearLiveStreams.length > 0) || (this.suggestLiveStreams.length > 0)">
                <ul class="nav nav-pills mb-3" style="display: flex; justify-content: center" id="pills-tab"
                  role="tablist">
                  <li class="nav-item">
                    <a class="nav-link" :class="{ active: activeTab === 'near' }" id="pills-near-live-tab"
                      data-bs-toggle="pill" href="#pills-near-live" role="tab" aria-controls="pills-near-live"
                      :aria-selected="activeTab === 'near' ? 'true' : 'false'">
                      البثوث القريبة <i class="fas fa-broadcast-tower"></i>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" :class="{ active: activeTab === 'suggest' }" id="pills-suggest-tab"
                      data-bs-toggle="pill" href="#pills-suggest" role="tab" aria-controls="pills-suggest"
                      :aria-selected="activeTab === 'suggest' ? 'true' : 'false'">
                      بثوث قد تعجبك <i class="fas fa-chalkboard-teacher"></i>
                    </a>
                  </li>
                </ul>

                <div class="tab-content">
                  <div class="tab-pane fade" :class="{ show: activeTab === 'near', active: activeTab === 'near' }"
                    id="pills-near-live" role="tabpanel" aria-labelledby="pills-near-live-tab">
                    <nearLive />
                  </div>
                  <div class="tab-pane fade" :class="{ show: activeTab === 'suggest', active: activeTab === 'suggest' }"
                    id="pills-suggest" role="tabpanel" aria-labelledby="pills-suggest-tab">
                    <suggestLive />
                  </div>
                </div>
              </div>


            </div>

          </div>


          <div class="col-xl-6" v-if="isLoggedIn == true">
            <!--begin::Engage widget 1-->
            <div class=" card h-xl-80 mt-2" dir="ltr">
              <!--begin::Body-->
              <div class="card-body d-flex flex-column flex-center">
                <!--begin::Heading-->
                <div class="mb-2">

                  <div class="text-center">
                    <img style="padding: 6px;border: 2px solid #17bc00;border-radius: 50%;" src="assets/img/galaxy.png"
                      class="theme-light-show w-100px" alt="">
                    <img style="padding: 6px;border: 2px solid #17bc00;border-radius: 50%;" src="assets/img/galaxy.png"
                      class="theme-dark-show w-100px" alt="">
                  </div>
                  <!--end::Illustration-->
                </div>
                <!--end::Heading-->
                <!--begin::Links-->
                <div class="text-center mb-1">
                  <!--begin::Link-->
                  <a href="qbank" style="font-size: 16px;background-color: #07c232;font-weight: 650;"
                    class=" btn btn-sm btn-success btn-lg  w-200px">بنك الأسئلة <i class="fa fa-arrow-circle-right"
                      style="font-size: 16px;"></i> </a>
                  <!--end::Link-->

                </div>
                <!--end::Links-->
              </div>
              <!--end::Body-->
            </div>
            <!--end::Engage widget 1-->
          </div>
          <div class="col-md-12" v-if="isloading == false && isLoggedIn == false">
            <infoDetails />
          </div>
          <div class="col-md-12" v-if="isloading == false">
            <h3 class=" text-center section-title">أبرز التخصصات</h3>

          </div>
          <div v-if="isloading == false" class=" col-md-6 col-xxl-4 mt-2 section-cats"
            v-for="(category, index) in categories" :key="'category-' + index">
            <!--begin::Card-->
            <div class="card">
              <!--begin::Card body-->
              <div class="card-body d-flex flex-center flex-column p-9">
                <!--begin::Wrapper-->
                <div class="mb-5">
                  <!--begin::Avatar-->
                  <div class="symbol symbol-75px">
                    <a @click.prevent="openModal(category.subcategory)">
                      <img :src="category.cat_image ? `${catImagePath}${category.cat_image}` : defaultImage"
                        @error="handleImageError" :data-category-id="category.id" :alt="category.name" />
                    </a>
                  </div>
                  <!--end::Avatar-->
                </div>
                <!--end::Wrapper-->
                <!--begin::Name-->
                <a href="#" @click.prevent="openModal(category.subcategory)"
                  class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0">
                  {{ category.title.en }}
                </a>

                <!--end::Name-->
                <!--begin::Position-->
                <div class="fw-semibold text-gray-400 mb-6">{{ category.description || "تخصصات أكاديميا" }}</div>
                <!--end::Position-->
                <!--begin::Link-->
                <!--<a :href="`/CategoryCourses?value_id=category_id&value=${category.id}`"
                  class="btn btn-sm btn-light-success fw-bold">
                  عرض <i class="fa fa-arrow-left"></i>
                </a>-->
                <!--end::Link-->
              </div>
              <!--end::Card body-->
            </div>
            <!--end::Card-->
          </div>
          <!--begin::Col-->
          <div class="col-sm-12 support" v-if="isloading == false">
            <!--begin::Address-->
            <div class="text-center bg-light card-rounded d-flex flex-column justify-content-center p-10 h-100">
              <!--begin::Icon-->
              <!--begin::Svg Icon | path: icons/duotune/general/gen018.svg-->
              <span class="svg-icon svg-icon-3tx svg-icon-primary">
                <i class="bi bi-telegram"></i>
              </span>
              <!--end::Svg Icon-->
              <!--end::Icon-->
              <!--begin::Subtitle-->
              <h1 class="text-dark fw-bold my-5">الدعم الفني</h1>
              <!--end::Subtitle-->
              <!--begin::Description-->
              <div class="text-gray-700 fs-3 fw-semibold"><a href="https://t.me/aca_demia" target="_blank"> 0913103064 (
                  تليغرام)</a> </div>
              <!--end::Description-->
            </div>
            <!--end::Address-->
          </div>
          <!--end::Col-->
        </div>
      </div>
    </div>
    <!--begin::Col-->

    <!--end::Col-->

  </div>
  <!-- هيكل المودال -->
  <div class="modal fade" id="subCatsModal" tabindex="-1" aria-labelledby="subCatsModalLabel" aria-hidden="true"
    ref="subCatsModal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <!-- عنوان المودال -->
        <div class="modal-header">
          <h5 class="modal-title" id="subCatsModalLabel"> التخصصات</h5>
          <button type="button" class="btn-close" @click="closeModal" aria-label="إغلاق"></button>
        </div>
        <!-- محتوى المودال -->
        <div class="modal-body" ref="subCatContent">
          <!-- المحتوى سيتم ملؤه هنا -->
        </div>
        <!-- تذييل المودال (اختياري) -->
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">إغلاق</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUrl, baseUrl } from "@/utils/api";
import infoDetails from "./infoDetails.vue";
import nearLive from "./nearLive.vue";
import suggestLive from "./suggestLive.vue";

export default {
  name: "Home",
  components: {
    infoDetails,
    nearLive,
    suggestLive,

  },
  data() {
    return {
      categories: [],
      subCategories: [],
      isloading: true,
      token: localStorage.getItem("access_token"),
      courseCount: 0,
      isLoggedIn: false,
      walletBalance: 0,
      catImagePath: baseUrl + "/images/category/",
      defaultImage: "/assets/img/acad-icon.png",
      student: {},
      mobile: '0',
      loadingCategories: true, // Loading state for categories
      loadingCourses: true, // Loading state for courses
      loadingBalance: true, // Loading state for wallet balance
      tab: 'nearLive', // لتحديد التاب النشط
      nearLiveStreams: [], // بيانات التاب الأول
      suggestLiveStreams: [] // بيانات التاب الثاني
    };
  },
  computed: {
    activeTab() {
      if (this.nearLiveStreams.length > 0) return 'near';
      if (this.suggestLiveStreams.length > 0) return 'suggest';
      return 'near'; // لو كلاهما فاضيين نعرض الأول كخيار افتراضي
    }
  },
  watch: {
    isloading(newVal) {
      if (newVal === false) {
        // DOM جاهز لتهيئة Flickity

      }
    }
  },
  mounted() {
    this.fetchCategories();
    this.fetchStudentDetails();
    this.getBalance();
    this.getNearLive();
    this.getsuggestLive();
  },
  methods: {
    openModal(subCategories) {
      // بناء محتوى المودال على شكل بطاقات مع روابط
      const cardHTML = subCategories.map(subCategory => `
    <div class="col-md-4 col-sm-6 mb-4">
      <div class="card text-center" style="color: #fff;cursor: pointer;background: #113954;" onclick="location.href='/CategoryCourses?value_id=subcategory_id&value=${subCategory.id}'">
        <div class="card-body">
          <h5 class="card-title" style="font-size:13px">${subCategory.title}</h5>
        </div>
      </div>
    </div>
  `).join('');

      // إضافة البطاقات إلى صف
      this.$refs.subCatContent.innerHTML = `
    <div class="row">
      ${cardHTML}
    </div>
  `;

      // فتح المودال باستخدام Bootstrap
      const modalElement = new bootstrap.Modal(this.$refs.subCatsModal);
      modalElement.show();
    },
    closeModal() {
      // إغلاق المودال
      const modalElement = bootstrap.Modal.getInstance(this.$refs.subCatsModal);
      if (modalElement) {
        modalElement.hide();
      }
    },
    async fetchCategories() {
      this.loadingCategories = true; // Start loading
      try {
        const response = await fetch(`${apiUrl}/home/web`);
        const jsonResponse = await response.json();
        this.categories = jsonResponse.allcategory;
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        this.loadingCategories = false; // Stop loading
      }
    },
    async fetchStudentDetails() {
      this.loadingCourses = true; // Start loading
      try {
        const response = await fetch(`${apiUrl}/desktop/my-courses`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {

          const data = await response.json();
          this.student = data.student;
          this.mobile = data.student.mobile;
          this.courseCount = data.courses.length;
          this.isLoggedIn = true;
          this.isloading = false;

        } else if (response.status === 401 || response.status === 403) {
          //this.$router.push("/logout");
          this.isloading = false;

        } else {
          console.error("Failed to fetch student details");
          this.isloading = false;

        }
        this.isloading = false;
      } catch (error) {
        console.error("Error fetching student details:", error);
        //this.$router.push("/logout");
      } finally {
        this.loadingCourses = false; // Stop loading
      }
    },
    async getBalance() {
      this.loadingBalance = true; // Start loading
      try {
        const response = await fetch(
          `${apiUrl}/wallets/get-balance?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          this.walletBalance = data.wallet_balance;
          this.isloading = false;

        } else {
          console.error("Failed to fetch balance");
          this.isloading = false;

        }
      } catch (error) {
        console.error("Error fetching balance:", error);
      } finally {
        this.loadingBalance = false; // Stop loading
        this.isloading = false;
      }
    },
    async getNearLive() {
      this.isLoadingStreams = true;
      try {
        const response = await fetch(`${apiUrl}/livestream/get-near-live-courses`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          this.nearLiveStreams = await response.json();
        } else {
          console.error("Failed to fetch live streams");
        }
      } catch (error) {
        console.error("Error fetching live streams:", error);
      } finally {
        this.isLoadingStreams = false;
      }
    },

    async getsuggestLive() {
      this.isLoadingStreams = true;
      try {
        const response = await fetch(`${apiUrl}/livestream/get-similar-courses`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          this.suggestLiveStreams = await response.json();
          console.log(this.suggestLiveStreams.length);

        } else {
          console.error("Failed to fetch live streams");
        }
      } catch (error) {
        console.error("Error fetching live streams:", error);
      } finally {
        this.isLoadingStreams = false;
      }
    },

    handleImageError(event) {
      // استبدال الصورة بصورة افتراضية إذا حدث خطأ مثل 404
      event.target.src = this.defaultImage;
    }
  },
};
</script>

<style scoped></style>
